import {defineAsyncComponent} from 'vue';

const EstimateTYAddContentPopup = defineAsyncComponent(() =>
  import('@/views/estimate/threeYearEstimate/popup/EstimateTYAddContentPopup.vue'),
);
const EstimateFinanceTYAddContentPopup = defineAsyncComponent(() =>
  import('@/views/estimateFinanceThreeYear/popup/EstimateFinanceTYAddContentPopup.vue'),
);
export function registerTYEstimate(app) {
  app.component('EstimateTYAddContentPopup', EstimateTYAddContentPopup);
  app.component('EstimateFinanceTYAddContentPopup', EstimateFinanceTYAddContentPopup);
}
